const PROD_BACKEND_URL = 'https://back.kanuda.pro';
const ENV_BACKEND_URL = (process.env.REACT_APP_API_BACKEND || '').trim();

export const API_BACKEND = (ENV_BACKEND_URL || PROD_BACKEND_URL).replace(/\/$/, '');
